module.exports={
    "dataExports": "Data exports (.xlsx)",
    "upgradeToProForAccess": "Upgrade to Pro for Access",
    "dataExportsRemaining": "Data exports remaining"
}
